<script setup lang="ts">
import type { PaginationEmits, PaginationProps, PaginationSlots } from '#ui/types';
import { useForwardPropsEmits } from 'reka-ui';
import Pagination from '#ui/components/Pagination.vue';

const { variant = 'ghost', activeColor = 'neutral', ...forwardedProps } = defineProps<PaginationProps>();
const emits = defineEmits<PaginationEmits>();
const slots = defineSlots<PaginationSlots>();

const forwarded = useForwardPropsEmits(() => ({ ...forwardedProps, variant, activeColor }), emits);
</script>

<template>
	<Pagination v-bind="forwarded">
		<template v-for="(_, name) in slots" #[name]="slotData: any">
			<slot :name v-bind="slotData" />
		</template>
	</Pagination>
</template>
